// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2pwb0","tab":"ProcedureTabs_tab__tGIWP"};